export class GameConfig {
  viewSettings: string[];
  muteIntegration?: boolean;
  standalone?: boolean;
  smartlookRequired?: boolean;
  forceFullScreen?: boolean;
}
export const GAMES_SETTINGS: {
  [key: string]: GameConfig;
} = {
  'tower-jelly': {
    viewSettings: ['portrait', 'tweensoft', 'fullheight'],
    standalone: true,
  },
  froggee: {
    viewSettings: ['tweensoft', 'fullheight'],
    muteIntegration: true,
    standalone: true,
  },
  'fruit-pop': { viewSettings: ['portrait', 'fullheight'] },
  'word-nerd': { viewSettings: ['landscape', 'fullscreen', 'fullheight'] },
  'snake-challenge-one-fruits': {
    viewSettings: ['landscape', 'fullscreen', 'fullheight'],
    muteIntegration: true,
    standalone: true,
  },
  'snake-challenge-five-fruits': {
    viewSettings: ['landscape', 'fullscreen', 'fullheight'],
    muteIntegration: true,
    standalone: true,
  },
  'pyramid-solitaire': {
    viewSettings: ['landscape', 'fullscreen', 'fullheight'],
    standalone: true,
  },
  'wooden-slide': {
    viewSettings: ['fullscreen', 'fullheight'],
    muteIntegration: true,
    standalone: true,
  },
  '9ballpool': {
    viewSettings: ['landscape', 'fullscreen', 'fullheight'],
    muteIntegration: true,
    standalone: true,
  },
  fruitblade: {
    viewSettings: ['landscape', 'fullscreen', 'fullheight'],
    muteIntegration: true,
    standalone: true,
  },
  'goose-hunter': {
    viewSettings: ['landscape', 'fullscreen', 'fullheight'],
    muteIntegration: true,
    standalone: true,
  },
  'temple-crossing': {
    viewSettings: ['landscape', 'fullscreen', 'fullheight'],
    muteIntegration: true,
  },
  'spore-hunter': {
    viewSettings: ['portrait', 'fullscreen', 'fullheight'],
    muteIntegration: true,
    standalone: true,
  },
  'mahjong-3d': {
    viewSettings: ['landscape', 'fullscreen', 'fullheight'],
    muteIntegration: true,
    standalone: true,
  },
  'solitaire-3-flip': {
    viewSettings: ['landscape', 'fullscreen', 'fullheight'],
    standalone: true,
  },
  'monkey-jump': {
    viewSettings: ['portrait', 'fullscreen', 'fullheight'],
    muteIntegration: true,
    standalone: true,
  },
  solitaire: {
    viewSettings: ['landscape', 'fullscreen', 'fullheight'],
    standalone: true,
  },
  'whack-a-mole': {
    viewSettings: ['portrait', 'fullheight'],
    muteIntegration: true,
    standalone: true,
  },
  'rally-champion': {
    viewSettings: ['landscape', 'fullscreen', 'fullheight'],
    muteIntegration: true,
    standalone: true,
  },
  'jewel-blocks-puzzle': {
    viewSettings: ['portrait', 'fullscreen', 'fullheight'],
    muteIntegration: true,
    standalone: true,
  },
  'cool-archer': {
    viewSettings: ['fullscreen', 'fullheight'],
    muteIntegration: true,
    standalone: true,
  },
  'soccer-challenge': {
    viewSettings: ['fullscreen', 'fullheight'],
    muteIntegration: true,
    standalone: true,
  },
  'basketball-challenge': {
    viewSettings: ['fullscreen', 'fullheight'],
    muteIntegration: true,
    standalone: true,
    smartlookRequired: true,
  },
  'hockey-challenge': {
    viewSettings: ['fullscreen', 'fullheight'],
    muteIntegration: true,
    standalone: true,
  },
  dominoes: {
    viewSettings: ['portrait', 'fullscreen', 'fullheight'],
    muteIntegration: true,
    forceFullScreen: true,
    standalone: true,
  },
  'bubble-up-endless': {
    viewSettings: ['portrait', 'fullscreen', 'fullheight'],
    muteIntegration: true,
    standalone: true,
  },
  '2048-remastered': {
    viewSettings: ['fullscreen', 'fullheight'],
    muteIntegration: true,
    standalone: true,
    smartlookRequired: true,
  },
};
export const GAME_CONSTANTS = {
  SOCKET_ERROR: 'game_socket_error',
  RESTART: 'restarting_game',
};
